<div class="overflow-hidden">
    <div class="modal-header">
        <div class="d-inline-flex align-items-center" *ngIf="data.point">
            <mat-icon matSuffix svgIcon="total-fill-data" class="red-color"></mat-icon>
            <h3>{{ 'pages.editInspectionDialog.title' | translate }} {{ data.point.label }}</h3>
        </div>
        <button mat-icon-button class="red-color" (click)="onCancel()">
            <mat-icon>close</mat-icon>
        </button>
    </div>
    <div class="modal-header">
        <h3>{{ 'pages.editInspectionDialog.inspection_data' | translate }}</h3>
        <div class="d-flex align-items-center">
            <button mat-raised-button color="accent" (click)="onPasteFromExcel()">
                <span class="mat-button-wrapper">
                    {{ 'pages.editInspectionDialog.paste_from_excel' | translate }}
                    <mat-icon matSuffix svgIcon="total-fill-data" class="paste-excel-icon"></mat-icon>
                </span>
            </button>
            <app-custom-popover [index]="1"
                [content]="'pages.editInspectionDialog.paste_from_excel_help'"
                [icon]="'total-info'"
                [tooltip]="'pages.editInspectionDialog.paste_from_excel_help'">
            </app-custom-popover>
        </div>
    </div>
    <div mat-dialog-content [formGroup]="form">

        <div class="row mb-3">
            <div class="col">
                <mat-label>{{ 'pages.editInspectionDialog.circPercent' | translate }} <span class="red-color">*</span>
                </mat-label>
                <mat-form-field appearance="outline" class="w-100 mt-1">
                    <input matInput formControlName="circPercent" type="number" step="0.01"/>
                    <mat-error *ngIf="circPercentControl?.hasError('required')">
                        {{ 'pages.editInspectionDialog.errors.required' | translate }}
                    </mat-error>
                    <mat-error *ngIf="circPercentControl?.hasError('positiveRequired')">
                        {{ 'pages.editInspectionDialog.errors.positiveRequired' | translate }}
                    </mat-error>
                    <mat-error *ngIf="circPercentControl?.hasError('maxValue')">
                        {{ 'pages.editInspectionDialog.errors.maxValueOne' | translate }}
                    </mat-error>
                    <mat-error *ngIf="circPercentControl?.hasError('notANumber')">
                        {{ 'pages.editInspectionDialog.errors.notANumber' | translate }}
                    </mat-error>
                </mat-form-field>
            </div>
            <div class="col">
                <mat-label>{{ 'pages.editInspectionDialog.length' | translate }}<span class="red-color">*</span>
                </mat-label>
                <mat-form-field appearance="outline" class="w-100 mt-1">
                    <input matInput formControlName="length" type="number" step="0.01"/>
                    <mat-error *ngIf="lengthControl?.hasError('required')">
                        {{ 'pages.editInspectionDialog.errors.required' | translate }}
                    </mat-error>
                    <mat-error *ngIf="lengthControl?.hasError('positiveRequired')">
                        {{ 'pages.editInspectionDialog.errors.positiveRequired' | translate }}
                    </mat-error>
                    <mat-error *ngIf="lengthControl?.hasError('notANumber')">
                        {{ 'pages.editInspectionDialog.errors.notANumber' | translate }}
                    </mat-error>
                </mat-form-field>
            </div>
        </div>

        <app-inspection-table
                [previousInspections]="previousInspectionsList"
                [currentInspection]="draftInspection"
                [formArray]="measurementsArray"
                [threshold]="data.point.initialUncoorTHK"
        >
        </app-inspection-table>

        <!-- Message d'erreur pour la validation des mesures -->
        <div *ngIf="getMeasurementsValidationMessage()" class="alert alert-danger mt-2">
            {{ getMeasurementsValidationMessage() | translate }}
        </div>

        <!-- Indicateur du nombre de mesures actuelles -->
        <div class="mt-2">
            {{
                'pages.editInspectionDialog.validMeasurementsCount' | translate: {
                    count: getValidMeasurementsCount(),
                    minimum: 10
                }
            }}
        </div>

    </div>

    <div mat-dialog-actions class="modal-footer">
        <div>
            <span class="red-color">*</span> {{ 'pages.user_modal.mandatory' | translate }}
        </div>
        <div>
            <button mat-button (click)="onCancel()">{{ 'general.actions.cancel' | translate }}</button>
            <button mat-raised-button color="primary" (click)="onSave()"
                    [disabled]="isFormInvalid()">{{ 'general.actions.save' | translate }}
            </button>
        </div>
    </div>
</div>
